import { INVALID_PARAMETER } from '../constants/api-error-enums';

export const CHECKOUT_ERRORS = {
  CARDID_MISSING: 'CARDID_MISSING',
  DPA_TRANSACTION_OPTIONS: 'dpaTransactionOptions',
  ENCRYPTED_CARD: 'encryptedCard',
  INVALID_PARAMETER,
  SRC_DIGITAL_CARD_ID: 'srcDigitalCardId'
};

export const DCF_ACTION_CODE = 'ERROR';

export const UNABLE_TO_CONNECT = 'Unable to connect to DCF';

export default CHECKOUT_ERRORS;
